module.exports = __webpack_public_path__ + "static/media/growpital.60fc220b.svg";